import * as Yup from "yup";

const perfilUsuarioValidator = Yup.object().shape({
  nome: Yup.string().required("Nome"),
});

export default perfilUsuarioValidator;
